import Highway from '@dogstudio/highway';
import Infos from '../_modules/infos';
import Slideshow from '../_modules/slideshow';
import Menu from '../_modules/menu';
import AgenceLinks from '../_modules/agenceLinks';

class Agence extends Highway.Renderer {
  onEnter() {
    Infos.init();
    Slideshow.init();
    Menu.init();
  }
  onEnterCompleted() {
    AgenceLinks.init();
  }
}

export default Agence;
